export default {"src":"/_next/static/media/gap-assessment.868dc06e.svg","height":834,"width":834,"blurWidth":0,"blurHeight":0};